/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brave_Talk_HeadingInputs */

const en_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const id_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Bicara`)
};

const ms_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const ca_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converses de Brave`)
};

const cs_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const da_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Videoopkald`)
};

const de_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const et_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const es_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videollamadas Brave`)
};

const fr_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appels Brave`)
};

const hr_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const it_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoconferenze Brave`)
};

const lv_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave sarunas`)
};

const lt_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Brave“ Kalbėkite`)
};

const hu_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave videóhívás`)
};

const nl_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const nb_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const pl_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const pt_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const ro_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const sk_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const sl_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Pogovor`)
};

const fi_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const sv_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave-samtal`)
};

const vi_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trò chuyện Brave`)
};

const tr_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const el_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Συνομιλία Brave`)
};

const bg_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const ru_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разговоры Brave`)
};

const sr_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const uk_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const ka_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const hi_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const th_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const ko_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave 토크`)
};

const zh_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

const zh_tw_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave 視訊通話`)
};

const ja_brave_talk_heading = /** @type {(inputs: Brave_Talk_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Talk`)
};

/**
* | output |
* | --- |
* | "Brave Talk" |
*
* @param {Brave_Talk_HeadingInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const brave_talk_heading = /** @type {((inputs?: Brave_Talk_HeadingInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brave_Talk_HeadingInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_brave_talk_heading(inputs)
	if (locale === "ms") return ms_brave_talk_heading(inputs)
	if (locale === "ca") return ca_brave_talk_heading(inputs)
	if (locale === "cs") return cs_brave_talk_heading(inputs)
	if (locale === "da") return da_brave_talk_heading(inputs)
	if (locale === "de") return de_brave_talk_heading(inputs)
	if (locale === "et") return et_brave_talk_heading(inputs)
	if (locale === "es") return es_brave_talk_heading(inputs)
	if (locale === "fr") return fr_brave_talk_heading(inputs)
	if (locale === "hr") return hr_brave_talk_heading(inputs)
	if (locale === "it") return it_brave_talk_heading(inputs)
	if (locale === "lv") return lv_brave_talk_heading(inputs)
	if (locale === "lt") return lt_brave_talk_heading(inputs)
	if (locale === "hu") return hu_brave_talk_heading(inputs)
	if (locale === "nl") return nl_brave_talk_heading(inputs)
	if (locale === "nb") return nb_brave_talk_heading(inputs)
	if (locale === "pl") return pl_brave_talk_heading(inputs)
	if (locale === "pt") return pt_brave_talk_heading(inputs)
	if (locale === "ro") return ro_brave_talk_heading(inputs)
	if (locale === "sk") return sk_brave_talk_heading(inputs)
	if (locale === "sl") return sl_brave_talk_heading(inputs)
	if (locale === "fi") return fi_brave_talk_heading(inputs)
	if (locale === "sv") return sv_brave_talk_heading(inputs)
	if (locale === "vi") return vi_brave_talk_heading(inputs)
	if (locale === "tr") return tr_brave_talk_heading(inputs)
	if (locale === "el") return el_brave_talk_heading(inputs)
	if (locale === "bg") return bg_brave_talk_heading(inputs)
	if (locale === "ru") return ru_brave_talk_heading(inputs)
	if (locale === "sr") return sr_brave_talk_heading(inputs)
	if (locale === "uk") return uk_brave_talk_heading(inputs)
	if (locale === "ka") return ka_brave_talk_heading(inputs)
	if (locale === "hi") return hi_brave_talk_heading(inputs)
	if (locale === "th") return th_brave_talk_heading(inputs)
	if (locale === "ko") return ko_brave_talk_heading(inputs)
	if (locale === "zh") return zh_brave_talk_heading(inputs)
	if (locale === "zh-tw") return zh_tw_brave_talk_heading(inputs)
	if (locale === "ja") return ja_brave_talk_heading(inputs)
	return en_brave_talk_heading(inputs)
});